// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f03fc833","186":"18bff230","225":"ab797597","272":"59737cb5","372":"26973afb","377":"101ab95c","738":"e7699e3e","841":"2bd94222","856":"314fa721"}[chunkId] + ".chunk.js";
};